import $http from '../../axios-instance';
import Swal from 'sweetalert2';

export async function listarListasChequeo({dispatch, state, commit}, parametros = {params: state.filtro}) {
  commit('dashboard/load', true, {root: true});
  await $http.get('adm_general/lista-chequeo', parametros)
    .then((response) => {
      commit('establecerListasChequeo', response.data.data);
      commit('dashboard/load', false, {root: true});
    }).catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, texto: error.mensaje});
    });
}

/**
 * Obtener empresas
 */
export async function obtenerEmpresas({dispatch, commit, state}, nombre) {
  dispatch('obtenerEmpresasPeticion', nombre)
    .then(empresas => commit('establecerEmpresas', empresas));
}

/**
 * Obtener empresas filtro
 */
export async function obtenerEmpresasFiltro({commit, dispatch}, nombre) {
  dispatch('obtenerEmpresasPeticion', nombre)
    .then(empresas => commit('establecerEmpresasFiltro', empresas));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerEmpresasPeticion({dispatch, commit, state}, nombre) {

  return await new Promise(async (resolve, reject) => {
    if (!state.cargando_datos_select && nombre && nombre.length > 1) {
      commit('establecerCargandoDatosSelect', true);

      let parametros = {
        params: {
          nombre: nombre
        }
      };

      await $http.get('/empresas/lista', parametros)
        .then((response) => {
          resolve(response.data.data);
          commit('establecerCargandoDatosSelect', false);
        })
        .catch(() => {
          console.warn('No se encontraron empresas con el nombre especificado');
          reject([]);
          commit('establecerCargandoDatosSelect', false);
        });
    }
  });
}

export async function listarHallazgos({dispatch, state, commit}) {

  const parametros = {
    params: state.filtro_hallazgos
  };

  commit('dashboard/load', true, {root: true});

  await $http.get(`empresas/hallazgos/${state.filtro_hallazgos.id_lista}`, parametros)
    .then((response) => {
      commit('establecerHallazgos', response.data.data);
      commit('dashboard/load', false, {root: true});
    }).catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, texto: error.mensaje});
    });
}

export async function crearSeguimiento({commit, state, dispatch}) {

  commit('dashboard/load', true, {root: true});

  await $http.post('empresas/seguimientos/crear', state.seguimiento)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      commit('establecerSeguimiento', response.data.seguimiento);
      commit('establecerAccion', 'Actualizar');
      await dispatch('mostrarMensaje', {error: false, texto: response.data.message});
    }).catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, texto: error.mensaje});
    });
}

export async function obtenerSeguimiento({dispatch, commit, state}) {

  commit('dashboard/load', true, {root: true});

  await $http.get(`empresas/seguimientos/mostrar/${state.seguimiento.id}/${state.seguimiento.id_empresa}`)
    .then((response) => {
      commit('establecerSeguimiento', response.data.data);
      commit('dashboard/load', false, {root: true});

    }).catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, texto: error.mensaje});
    });
}

export async function actualizarSeguimiento({dispatch, commit, state}) {

  commit('dashboard/load', true, {root: true});

  $http.put(`empresas/seguimientos/editar/${state.seguimiento.id}`, state.seguimiento)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: false, texto: response.data.message});
    }).catch(async (error) => {
    commit('dashboard/load', false, {root: true});
    await dispatch('mostrarMensaje', {error: true, texto: error.mensaje});
  });
}

export async function guardaImagen({dispatch, commit, state}, data) {

  commit('dashboard/load', true, {root: true});

  await $http.post('empresas/adjuntos-seguimientos/crear', data)
    .then(async (response) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: false, texto: response.data.message});
    }).catch(async (error) => {
      commit('dashboard/load', false, {root: true});
      await dispatch('mostrarMensaje', {error: true, texto: error.mensaje});
    });
}


export async function descargarAdjunto({state, commit, dispatch}, adjunto) {

  commit('dashboard/load', true, {root: true});
  let nombre = adjunto.adjunto;

  const parametros = {
    id_empresa: adjunto.id_empresa
  };

  await $http({
    url: `empresas/adjuntos-seguimientos/mostrar/${adjunto.id}`,
    method: 'GET',
    responseType: 'blob',
    params: parametros
  }).then((response) => {
    window.downloadFile(response.data,nombre);
    commit('dashboard/load', false, {root: true});
  }).catch(async (error) => {
    commit('dashboard/load', false, {root: true});
    await dispatch('mostrarMensaje', {error: true, texto: error.mensaje});
  });
}

export async function mostrarMensaje({}, datos) {
  await Swal.fire({
    position: 'center',
    icon: datos.error ? 'error' : 'success',
    title: datos.error ? 'Error' : 'Muy bien!',
    text: datos.texto,
    showConfirmButton: true,
    timer: 3000,
  });
}
